import { ReactElement } from 'react';
import { IBaseModel, IListFetchParams, useListContext } from '../../../common';
import { gridFieldsFormatRules } from '../../../utils';
import { cn } from '@jobcost-monorepo/utils';
import { Icon } from '@jobcost-monorepo/ui';
import React from 'react';

interface Props<T extends IBaseModel> {
  element: T;
  className?: string;
}

const GridRow = <T extends IBaseModel, Q extends IListFetchParams>({
  element,
  className,
}: Props<T>): ReactElement => {
  const { setFormElement, setFormOpen, setDeleteModalOpen, repository } =
    useListContext<T, Q>();

  const handleEdit = () => {
    setFormElement(element);
    setFormOpen(true);
  };

  const handleDelete = () => {
    setFormElement(element);
    setDeleteModalOpen(true);
  };

  return (
    <tr className={cn('w-full', className)}>
      {repository.gridFieldsOptions
        .filter((col) => col.visible)
        .sort((col1, col2) => col1.position - col2.position)
        .map((col, index) => (
          <td
            key={`${String(col.linkedField)}${index}`}
            align={col.align}
            width={col.width}
            className="p-3"
          >
            <div className="max-h-12 overflow-hidden">
              <span className="line-clamp-1">
                {gridFieldsFormatRules(
                  element,
                  col.linkedField,
                  col.formatType,
                  col.translationModuleName,
                  col.enumValues,
                )}
              </span>
            </div>
          </td>
        ))}

      <td className="p-3 flex flex-row justify-end cursor-pointer space-x-4 my-auto max-h-12">
        <div onClick={handleEdit}>
          <Icon
            iconName="edit"
            className="hover:opacity-50 fill-black stroke-black dark:fill-white dark:stroke-white"
          />
        </div>

        <div onClick={handleDelete}>
          <Icon
            iconName="remove"
            className="fill-pink stroke-pink hover:opacity-50"
          />
        </div>
      </td>
    </tr>
  );
};

export default GridRow;
